// extracted by mini-css-extract-plugin
module.exports = {"root":"HappyHornOverlay_root__1O-V9","wellDone":"HappyHornOverlay_wellDone__2wBxH","iconContainer":"HappyHornOverlay_iconContainer__85bP0"};